import { render } from "./DashboardAllocatedAccomplished.vue?vue&type=template&id=e1f0a0da&scoped=true&ts=true"
import script from "./DashboardAllocatedAccomplished.vue?vue&type=script&lang=ts"
export * from "./DashboardAllocatedAccomplished.vue?vue&type=script&lang=ts"

import "./DashboardAllocatedAccomplished.vue?vue&type=style&index=0&id=e1f0a0da&lang=scss&scoped=true"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1f0a0da"]])

export default __exports__